import { useDatabase } from "@nozbe/watermelondb/hooks";
import { useCallback } from "react";
import Customer from "../data/model/Customer";
import { OfflineSearchOptions, useOfflineQuery } from "../offline-search";
import { Q } from "@nozbe/watermelondb";
import { DEFAULT_SEARCH_LIMIT } from "../offline-search/constants";

export const useMakeBaseCustomerQuery = () => {
  const database = useDatabase();

  const customerCollection = database.collections.get<Customer>("customers");

  const makeBaseCustomerQuery = useCallback((term: string) => {
    const sanitizedTerm = Q.sanitizeLikeString(term);

    // computed field fullName search is not possible with watermelondb at this stage
    // as LokiJS does not support raw sql queries and
    // computed fields are not made available in the query builder
    const query = customerCollection.query(
      Q.where("email_address", Q.like(`%${sanitizedTerm}%`))
    );

    return query;
  }, []);

  return {
    makeBaseCustomerQuery,
  };
};

export const useOfflineCustomerSearch = () => {
  const { doQuery, ...result } = useOfflineQuery<Customer>();
  const { makeBaseCustomerQuery } = useMakeBaseCustomerQuery();

  const searchCustomers = useCallback(
    (term: string, options?: OfflineSearchOptions) => {
      const qb = makeBaseCustomerQuery(term);

      const extendedQuery = qb.extend(
        Q.take(options?.limit || DEFAULT_SEARCH_LIMIT)
      );

      return doQuery(extendedQuery);
    },
    []
  );

  return {
    searchCustomers,
    ...result,
  };
};
